import React, { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import mdFile from './press_release.md'

const PressRelease = () => {
const [postMarkdown, setPostMarkdown] = useState('');

// useEffect with an empty dependency array (`[]`) runs only once
useEffect(() => {
  fetch(mdFile)
    .then((response) => response.text())
    .then((text) => {
      // Logs a string of Markdown content.
      // Now you could use e.g. <rexxars/react-markdown> to render it.
      // console.log(text);
      setPostMarkdown(text);
    });
}, []);

  return <ReactMarkdown>{postMarkdown}</ReactMarkdown> ;
}

export default PressRelease;
